(function ($, Drupal, Router) {
  'use strict';

  /**
   * Trigger slick carousel for Collection Brick images
   */

  var collectionsBrickV1 = {
    template: $('.collections-brick-v1'),
    autoplaySpeed: 3000,
    transitionSpeed: 300
  };

  Drupal.behaviors.collectionsBrickV1 = {
    get: function (key) {
      return collectionsBrickV1[key];
    },

    set: function (key, val) {
      collectionsBrickV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var $template = $(self.get('template'), context);

      $template.each(function () {
        var $thisTemplate = $(this);
        var $carousel = $thisTemplate.find('.carousel > ul');
        var slide = '.carousel-slide';
        var autoplaySpeed = self.get('autoplaySpeed');
        var speed = self.get('transitionSpeed');
        var $appendArrows = $carousel.parent('.collection-landing-brick__carousel')
          .siblings('.collection-landing-brick__caption')
          .find('.collection-landing-brick__caption-inner');
        var autoplay = _.isUndefined($carousel.attr('data-slides-autoplay')) ? false : true;
        /*
       * Access an image slide via URL
       */
        var initialSlide = 0;
        var numSlides = $(slide, $thisTemplate).length;
        var accessImageSlide = function accessImageSlide(imageSlide) {
        // Just in case something other than a number is passed through
          if (_.isNaN(imageSlide)) {
            return;
          } else {
          // Only start on a slide number that exists
            if (imageSlide <= numSlides) {
              initialSlide = imageSlide - 1; // zero-based
            } else {
              return;
            }
          }
        };
        // Define route
        var routes = {
          '/collections-detail': {
            '/slide/:imageSlide': {
              on: accessImageSlide
            }
          }
        };
        // Director initialization
        var router = Router(routes);

        router.init();

        /*
       * Initialize Slick carousel with options
       *
       * afterChange:
       * We only want to loop the carousel just once, landing on either the
       * first slide or a specific slide via the URL (initialSlide).
       */
        var isRTL = site.direction.isRTL && Drupal?.settings?.forceSlickRTL;
        // swipe/drag direction is opposite when in RTL
        // so better to just disable it until a fix is provided in the library
        var swipe = isRTL ? false : true;
        var draggable = swipe;

        $carousel.slick({
          rtl: isRTL,
      	swipe: swipe,
      	draggable: draggable,
          appendArrows: $appendArrows,
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed,
          dots: false,
          infinite: true,
          initialSlide: initialSlide,
          slide: slide,
          slidesToShow: 1,
          slidesToScroll: 1,
          accessibility: true,
          speed: speed
        }).on('afterChange', function (slick, currentSlide) {
          if (currentSlide.currentSlide == initialSlide) {
            $(this).slick('slickPause');
          }
        });
      });
    }
  };
})(jQuery, Drupal, Router);
